import { render } from "./MenuItems.vue?vue&type=template&id=3cd157a4"
import script from "./MenuItems.vue?vue&type=script&lang=js"
export * from "./MenuItems.vue?vue&type=script&lang=js"

import "./MenuItems.vue?vue&type=style&index=0&id=3cd157a4&lang=scss&scope=true"

import exportComponent from "/builds/smartcom-gitlab-cis/maap/Application/Frontends/ProSpace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__